
(() => {
  'use strict';

  const initCSCL = (scope = document) => {
    const sections = [];

    if (scope instanceof Element && scope.matches('[data-cscl-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('[data-cscl-section]').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.csclInitialized === 'true') return;
      section.dataset.csclInitialized = 'true';

      const modal = section.querySelector('[data-cscl-modal]');
      const modalImage = section.querySelector('[data-cscl-modal-image]');
      const modalTitle = section.querySelector('[data-cscl-modal-title]');
      const modalPrice = section.querySelector('[data-cscl-modal-price]');
      const modalCompare = section.querySelector('[data-cscl-modal-compare]');
      const modalDiscount = section.querySelector('[data-cscl-modal-discount]');
      const modalDescription = section.querySelector('[data-cscl-modal-description]');
      const modalVariant = section.querySelector('[data-cscl-modal-variant]');
      const modalCart = section.querySelector('[data-cscl-modal-cart]');
      const modalLink = section.querySelector('[data-cscl-modal-link]');

      let lastTrigger = null;
      let requestInProgress = false;

      const cartRoot = () => window.Shopify?.routes?.root || '/';

      const refreshCartCount = async () => {
        try {
          const response = await fetch(`${cartRoot()}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });

          if (!response.ok) return;
          const cart = await response.json();

          document.querySelectorAll('[data-csa-cart-count]').forEach((node) => {
            node.textContent = cart.item_count;
            node.hidden = cart.item_count <= 0;
          });

          document.querySelectorAll('[data-cart-count-bubble]').forEach((node) => {
            node.textContent = cart.item_count;
            node.hidden = cart.item_count <= 0;
          });
        } catch (error) {
          console.error('CSCL: Cart count update failed.', error);
        }
      };

      const closeModal = () => {
        if (!modal) return;

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('CSCL-modal-open');

        if (lastTrigger?.isConnected) {
          lastTrigger.focus({ preventScroll: true });
        }
      };

      const openModal = (button) => {
        if (!modal) return;

        lastTrigger = button;
        modalTitle.textContent = button.dataset.title || '';
        modalPrice.textContent = button.dataset.price || '';
        modalCompare.textContent = button.dataset.compare || '';
        modalDiscount.textContent = button.dataset.compare && button.dataset.discount
          ? `${button.dataset.discount}% OFF`
          : '';
        modalDescription.textContent = button.dataset.description || '';
        modalVariant.value = button.dataset.variant || '';
        modalLink.href = button.dataset.url || '#';

        if (button.dataset.image) {
          modalImage.src = button.dataset.image;
          modalImage.alt = button.dataset.imageAlt || button.dataset.title || '';
          modalImage.hidden = false;
        } else {
          modalImage.removeAttribute('src');
          modalImage.alt = '';
          modalImage.hidden = true;
        }

        const available = button.dataset.available === 'true';
        modalCart.disabled = !available || !modalVariant.value;
        modalCart.textContent = available ? 'Add To Cart' : 'Sold Out';

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('CSCL-modal-open');
        modal.querySelector('[data-cscl-close]')?.focus({ preventScroll: true });
      };

      const openCart = (result) => {
        const drawer = document.querySelector('cart-drawer');

        if (drawer && typeof drawer.renderContents === 'function' && result?.sections) {
          try {
            drawer.renderContents(result);
            return;
          } catch (error) {
            console.warn('CSCL: Could not refresh Dawn cart drawer.', error);
          }
        }

        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return;
        }

        /* If this theme uses a separate custom cart drawer, announce the cart update. */
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
      };

      const addToCart = async (form, button) => {
        if (requestInProgress || button.disabled) return;

        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput?.value) return;

        requestInProgress = true;
        const originalText = button.textContent.trim();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding...';

        try {
          const formData = new FormData(form);
          formData.set('id', variantInput.value);
          formData.set('quantity', formData.get('quantity') || '1');
          formData.set('sections', 'cart-drawer,cart-icon-bubble');
          formData.set('sections_url', window.location.pathname);

          const response = await fetch(`${cartRoot()}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
            credentials: 'same-origin'
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || 'Unable to add product.');
          }

          await refreshCartCount();

          if (modal?.contains(form)) closeModal();
          openCart(result);

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
          button.textContent = 'Added!';

          window.setTimeout(() => {
            if (button.isConnected) button.textContent = originalText;
          }, 1500);
        } catch (error) {
          console.error('CSCL: Add to cart failed.', error);
          button.textContent = error.message || 'Please try again';

          window.setTimeout(() => {
            if (button.isConnected) button.textContent = originalText;
          }, 2500);
        } finally {
          requestInProgress = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };

      section.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const quickView = target.closest('[data-cscl-quick-view]');
        if (quickView && section.contains(quickView)) {
          event.preventDefault();
          openModal(quickView);
          return;
        }

        const closeButton = target.closest('[data-cscl-close]');
        if (closeButton && modal?.contains(closeButton)) {
          event.preventDefault();
          closeModal();
          return;
        }

        const wishlist = target.closest('[data-cscl-wishlist]');
        if (wishlist && section.contains(wishlist)) {
          const active = wishlist.getAttribute('aria-pressed') !== 'true';
          wishlist.setAttribute('aria-pressed', String(active));
        }
      });

      section.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        if (!form.matches('.CSCL-cart-form, .CSCL-modal-cart-form')) return;

        event.preventDefault();
        const button = event.submitter || form.querySelector('[type="submit"]');
        if (button) addToCart(form, button);
      });

      modal?.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      document.addEventListener('keydown', (event) => {
        if (modal?.classList.contains('is-open') && event.key === 'Escape') {
          closeModal();
        }
      });

      const sortSelect = section.querySelector('select[name="sort_by"]');
      sortSelect?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  };

  const start = () => initCSCL(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCSCL(event.target);
  });
})();
